import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef, useCallback } from "react";
import Select from "react-select";
import ErrorMessage from "./ErrorMessage";

const baseCustomStyles = {
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    width: "0",
  }),
  IndicatorsContainer: (provided) => ({
    ...provided,
    height: "44px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "44px",
    padding: "0 0 0 14px",
  }),
  placeholder: (provided) => ({
    ...provided,
    marginLeft: "0",
    marginRight: "0",
    color: "#aaa",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#444",
    marginLeft: "0",
    marginRight: "0",
    fontSize: "14px",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    paddingBottom: "0px",
    paddingTop: "0px",
    minWidth: "3em",
    color: "#444",
    width: "5em",
  }),
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? "none" : "none",
    backgroundColor: state.isFocused ? "#e6e6e6" : "#e6e6e6",
  }),
  menu: (provided) => ({
    ...provided,
    color: "#1B1E21",
    zIndex: 1,
  }),
};

const SelectField = forwardRef((props, ref) => {
  const {
    error,
    className,
    title,
    customStyles = {},
    caption,
    required,
    onMenuOpen,
    ..._props
  } = props;

  const selectStyles = Object.assign({}, baseCustomStyles, customStyles);

  const handleMenuOpen = useCallback(() => {
    if (onMenuOpen) {
      onMenuOpen();
    }
    setTimeout(() => {
      const menu = document.querySelector(".react-select__menu-list");
      const selectedEl = document.querySelector(
        ".react-select__option--is-selected"
      );
      if (menu && selectedEl) {
        menu.scrollTo(0, selectedEl.offsetTop);
        selectedEl.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }
    }, 15);
  }, [onMenuOpen]);

  return (
    <div className={styles.inputField}>
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.required]: required,
          })}
        >
          {title}
        </legend>
      )}
      <div className={classnames(styles.select, className)}>
        <Select
          styles={selectStyles}
          ref={ref}
          className="react-select-container"
          classNamePrefix="react-select"
          required={required}
          isSearchable={false}
          onMenuOpen={handleMenuOpen}
          {..._props}
        />
      </div>
      {caption && <p className={styles.caption}>{caption}</p>}
      {error && <ErrorMessage msg={error} />}
    </div>
  );
});
SelectField.displayName = "SelectField";
export default SelectField;
